/** Logistics rows on an order list/detail payload. */
export function getOrderLogisticsEntries(order) {
    if (!order) return [];
    if (Array.isArray(order.logistic)) return order.logistic;
    if (Array.isArray(order.logistics)) return order.logistics;
    if (order.logistics && typeof order.logistics === "object") return [order.logistics];
    return [];
}

/** At least one saved shipment with a logistics partner (matches AddShipment minimum). */
export function hasOrderLogisticsDetails(order) {
    if (!order) return false;

    const entries = getOrderLogisticsEntries(order);
    if (entries.length > 0) {
        return entries.some((entry) => String(entry?.provider || "").trim().length > 0);
    }

    // Shipping tracking dashboard rows expose provider on the item itself
    return String(order?.provider || "").trim().length > 0;
}

export function requiresLogisticsBeforeDispatch(currentStatus, newStatus) {
    return currentStatus === "READY_TO_DISPATCH" && newStatus === "DISPATCHED";
}

export const LOGISTICS_REQUIRED_FOR_DISPATCH_MSG =
    "Add logistics details before marking the order as Dispatched. Open Logi. and save shipment.";

export function canTransitionToDispatched(order, newStatus, { orderType } = {}) {
    const resolvedOrderType = orderType ?? order?.order_type;
    if (resolvedOrderType && resolvedOrderType !== "B2C") {
        return { allowed: true };
    }

    const currentStatus = order?.status ?? order?.delivery_status;
    if (!requiresLogisticsBeforeDispatch(currentStatus, newStatus)) {
        return { allowed: true };
    }
    if (hasOrderLogisticsDetails(order)) {
        return { allowed: true };
    }
    return { allowed: false, message: LOGISTICS_REQUIRED_FOR_DISPATCH_MSG };
}
